<template>
  <div class="about-page">
    <!-- 头部 -->
    <AppHeader />

    <!-- Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>

    <!-- 关于我们 -->
    <section class="section intro-section">
      <div class="container">
        <div class="intro-wrapper">
          <div class="intro-text">
            <div class="section-label-top">ABOUT US</div>
            <h2 class="section-heading" style="text-align: left;">关于我们</h2>
            <p class="intro-desc">{{ aboutText }}</p>
          </div>
          <div class="intro-image">
            <img src="//20684708.s61i.faiusr.com/2/AD0IpL-uCRACGAAgtsTK7QUo6Y3jmgcwtAM4jQQ.jpg" alt="关于我们">
          </div>
        </div>
      </div>
    </section>

    <!-- 企业优势 -->
    <section class="section advantage-section">
      <div class="container" style="background-color: #323232;padding: 50px 0 0 0;">
        <div class="advantage-wrapper">
          <div class="advantage-text" style="text-align: left;padding-left: 60px;">
            <h3 class="advantage-title-en">CORPORATE ADVANTAGE</h3>
            <div class="advantage-title-cn">企业优势</div>
            <p class="advantage-desc">{{ advantageText }}</p>
          </div>
          <div class="advantage-image">
            <img src="//20684708.s61i.faiusr.com/2/AD0IpL-uCRACGAAg8cXK7QUohO6ozAIwtAM4hgM.jpg" alt="企业优势">
          </div>
        </div>
      </div>
    </section>

    <!-- 合作生态 -->
    <section class="section ecology-section">
      <div class="container">
        <div class="section-label">Cooperative ecology</div>
        <h2 class="section-heading">合作生态</h2>
        <div class="ecology-logos">
          <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgrZq7zwYowr_v3QcwsBM42Ak!1500x1500.png" alt="合作品牌">
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="section contact-section">
      <div class="container">
        <div class="section-label">CONTACT US</div>
        <h2 class="section-heading">联系我们</h2>
        <p class="contact-subtitle">如果有任何问题请联系我们，我们7*24小时竭诚为您服务</p>
        <div class="contact-phone">400-966-5938</div>
        
        <div class="contact-cards">
          <div class="contact-card">
            <div class="contact-card-bg"></div>
            <div class="contact-card-inner">
              <img class="contact-icon" src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgrZu8zwYo0NSrsgYwsAk4sAk!60x60.png" alt="在线客服">
              <div class="contact-info">
                <div class="contact-label">在线客服</div>
                <div class="contact-value">400-966-5938</div>
              </div>
            </div>
          </div>
          <div class="contact-card">
            <div class="contact-card-bg"></div>
            <div class="contact-card-inner">
              <img class="contact-icon" src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgg5y8zwYogpKNNzCwCTiwCQ!60x60.png" alt="邮箱">
              <div class="contact-info">
                <div class="contact-label">邮箱</div>
                <div class="contact-value">bjyuexiangfuwu@126.com</div>
              </div>
            </div>
          </div>
          <div class="contact-card">
            <div class="contact-card-bg"></div>
            <div class="contact-card-inner">
              <img class="contact-icon" src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgm5y8zwYorprnVDCwCTiwCQ!60x60.png" alt="微信公众号">
              <div class="contact-info">
                <div class="contact-label">微信公众号搜</div>
                <div class="contact-value">悦享聚汇</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

     

    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'

export default {
  name: 'About',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      bannerImage: '//20684708.s61i.faiusr.com/2/AD0IpL-uCRACGAAgjsPK7QUo2sy--AYwgA84rAI.jpg',
      aboutText: '悦享聚汇，诞生于对企业人文关怀与员工福祉的深刻洞察，是国内领先的数字化员工福利整合解决方案供给平台。我们不仅提供产品，更致力于为企业构建有温度、有深度的关怀文化体系，成为连接企业与员工的情感纽带。\n\n悦享聚汇立足全国，服务覆盖全国600+城市，精选40万+优质产品，携手1600+知名品牌，已为1500+家企业提供高品质的福利定制服务。作为一站式员工福利生态平台，悦享聚汇始终秉持"创新、用心、真心"的服务理念，依托强大的资源整合与技术支撑，打造包含文化福利、生日关怀、节日慰问、餐补、线上线下活动、优惠券等多重场景的综合性福利体系。\n\n我们致力于让企业关怀触手可及，大幅降低福利管理与沟通成本，简化发放流程，提升员工体验，让每一次福利发放都成为一次愉悦的体验，让关怀真正融入员工日常生活的每个场景，实现企业与员工的共赢共生，共同体验悦享聚汇所带来的无限可能。',
      advantageText: '我们以全链路员工福利解决方案为核心，依托强大的技术中台与物流网络，打造集品质福利供应、定制化服务与数字运营支持于一体的优势体系：通过超级商城、文化福利、增值服务及生日福利等多元品类保障供应品质，提供定制化福利策略咨询、智能选品配送与多模态兑换体系的专业支持，并可围绕党群建设、员工关怀、节日礼品、个性化需求及定制礼品打造灵活方案，同时实现全流程在线管理、便捷下单与物流实时查询，为企业提供专属视觉与内容赋能、合规高效的福利发放方案，优化管理效率、助力企业文化建设，也为员工提供全方位优质商品选择，满足个性化需求，让福利更具实用性，实现企业与员工的双向价值提升。',
      footerNavItems: ['关于我们', '福利优选', '年节礼包', '生日卡券', '电影演出', '悦动态']
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif; color: #353535; line-height: 1.6; }

.about-page { background: #fff; }

/* Banner */
.banner {
  height: 300px;
  background-size: cover;
  background-position: 50% 50%;
}

/* 通用 */
.section { padding: 80px 0; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
}
.section-label-top {
  color: #e5e5e5;
  font-size: 36px;
  margin-bottom: 10px;
}
.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 40px;
}

/* 关于我们 */
.intro-wrapper {
  display: grid;
  grid-template-columns: 594px 1fr;
  gap: 40px;
  align-items: start;text-align: left;
}
.intro-text {
  text-align: left;
  padding-top: 34px;
}
.intro-desc {text-align: left;
  font-size: 14px;
  line-height: 30px;
  color: #353535;
  white-space: pre-line;
}
.intro-image img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

/* 企业优势 */
.advantage-section {
  background:url(../src/assets/7.jpg) no-repeat;
  width: 100%;
  background-size: cover;
  height: 600px;
}
.advantage-wrapper {
  display: grid;
  grid-template-columns: 1fr 436px;
  gap: 170px;
  align-items: start;
}
.advantage-title-en {
  font-size: 36px;
  color: #4d4d4d;
  margin-bottom: 8px;
}
.advantage-title-cn {
  font-size: 36px;
  font-weight: bold;
  color: #f1f1f1;
  margin-bottom: 30px;
}
.advantage-desc {
  font-size: 14px;
  line-height: 30px;
  color: #999;
}
.advantage-image img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

/* 合作生态 */
.ecology-section {
  background: #fafafa;
}
.ecology-logos {
  margin-top: 50px;
  text-align: center;
}
.ecology-logos img {
  max-width: 100%;
  height: auto;
}

/* 联系我们 */
.contact-section {
  background: #fff;
}
.contact-subtitle {
  text-align: center;
  font-size: 16px;
  color: #4c4c4c;
  margin-bottom: 10px;
}
.contact-phone {
  text-align: center;
  font-size: 36px;
  color: #4c4c4c;
  font-weight: bold;
  margin-bottom: 50px;
}
.contact-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}
.contact-card {
  position: relative;
  height: 150px;
}
.contact-card-bg {
  position: absolute;
  inset: 0;
  border-radius: 4px;
  background-image: url('//20684708.s61i.faiusr.com/4/AD0IpL-uCRAEGAAg5NbU7QUo_OyyvgYwygI4Wg.png');
  background-size: cover;
  opacity: 0.06;
}
.contact-card-inner {border: 1px solid #e1e1e1;
    border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100%;
  padding: 20px;
}
.contact-icon {
  width: 50px;
  height: 50px;
}
.contact-info {
  text-align: left;
}
.contact-label {
  font-size: 16px;
  color: #4c4c4c;
  margin-bottom: 4px;
}
.contact-value {
  font-size: 14px;
  color: #4c4c4c;
}

/* 底部导航 */
.footer-nav-section {
  background: #2c2c2c;
  padding: 60px 0;
}
.footer-nav-wrapper {
  display: grid;
  grid-template-columns: 274px 1fr 80px;
  gap: 60px;
  align-items: start;
}
.footer-nav-title {
  color: #fff;
  font-size: 14px;
  margin-bottom: 20px;
}
.footer-nav-list {
  list-style: none;
  line-height: 48px;
}
.footer-nav-list li {
  color: rgba(255, 255, 255, 0.69);
  font-size: 14px;
  cursor: pointer;
}
.footer-contact-info {
  color: #c6c6c6;
  font-size: 14px;
  line-height: 48px;
}
.footer-qr {
  width: 49px;
  height: 50px;
  margin-top: 43px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .intro-wrapper,
  .advantage-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .contact-cards {
    grid-template-columns: 1fr;
  }
  .footer-nav-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/About.vue